// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__a6Wy4","tabsList":"Tabs_tabsList__SCrJQ","tabsTrigger":"Tabs_tabsTrigger__cFXOp","tabsContent":"Tabs_tabsContent__wUXaN"};